import {FailCallback, fetchFile, sendRequest} from "../../util/http/HTTP";
import {ApiCampaign} from "../../util/http/API";
import {Group} from "./dataForGroup";
import {check3DigitalNumber, formatDateTime, formatDoctorName} from "../../util/util";
import {DropdownListFormNotSelectedStringId, DropdownListItem} from "../../components/forms/dropdownListForm";
import {AgeType, GroupEmployee, NewGroupSetting} from "./newGroup";
import {ChronicDisease, PatientPreview} from "./dataForPatientPreview";
import moment from "moment";
import {TimeFormat} from "../../util/enum";
import {LastDOS} from "./dataForNewGroup";
import {CodeItem, CodeSelectorType, CodeTemplateItem, ICDType} from "./codeSelector";
import {PatientSortConfig, SelectPatient} from "./patientPreviewList";
import {OpenRate, SubscribeStatus} from "./patientFilter";
import {Patient} from "./dataForPatients";

export const searchGroupListByName = (mEmployeeID: number, groupName: string, success: (groupList: Array<Group>, total: number) => void, fail: FailCallback) => {
    getGroupListByPage(1, 0, mEmployeeID, groupName, ["TargetPatients"], success, fail)
}

export const getGroupList = (mEmployeeID: number, page: number, pageSize: number, success: (groupList: Array<Group>, total: number) => void, fail: FailCallback) => {
    getGroupListByPage(page, pageSize, mEmployeeID, "", [], success, fail)
}

export const getGroupListByPage = (page: number, pageSize: number, mEmployeeID: number, groupName: string, excludeField: Array<string>,
    success: (groupList: Array<Group>, total: number) => void, fail: FailCallback) => {
    const param = {
        "pageId": page,
        "onePageCount": pageSize,
        "keyWord": groupName,
        "mEmployeeID": mEmployeeID,
        "excludeFields": excludeField,
        "onlyGetTargetPatientsCount": 1,
    }
    sendRequest(ApiCampaign.getPatientGroups, param, (response) => {
        let list: Array<Group> = []
        let total: number = 0
        if (response && response.data) {
            list = response.data.map((_item: any) => {
                let createBy = ""
                if (_item.employee) {
                    createBy = formatDoctorName(_item.employee.employeeFirstName, _item.employee.employeeLastName)
                }
                return {
                    id: _item.groupId,
                    name: _item.groupName,
                    size: _item.targetPatientsCount,
                    lastUpdated: formatDateTime(_item.lastUpdatePatientDate),
                    createBy: createBy,
                    patientPanel: _item.patientPanel,
                    source: _item,
                }
            })
            total = response.totalCount
        }
        success(list, total)
    }, fail)
}

export const getAppointmentTypes = (clinicID: number | string, success: (types: Array<DropdownListItem>) => void, fail?: FailCallback) => {
    const param = {
        clinicID: clinicID,
    }
    sendRequest(ApiCampaign.getAppointmentType, param, (response) => {
        let list: Array<DropdownListItem> = []
        if (response.data && response.data.length) {
            list = response.data.map((_item: any) => {
                return {
                    name: _item.businessTypeName,
                    id: _item.businessTypeID ? _item.businessTypeID.toString() : "",
                }
            })
        }
        success(list)
    }, fail)
}

export const getPatientInsurance = (clinicID: number | string, success: (list: Array<DropdownListItem>) => void, fail?: FailCallback) => {
    const param = {
        clinicID: clinicID,
    }
    sendRequest(ApiCampaign.getPatientInsurances, param, (response) => {
        let list: Array<DropdownListItem> = []
        if (response.data && response.data.length) {
            list = response.data.map((_item: any) => {
                // {"insuComSubmitterID":"iuuy78          ","insuComName":"0 1st insurance"}
                return {
                    name: _item.insuComName ? _item.insuComName.trim() : "",
                    id: _item.insuComSubmitterID ? _item.insuComSubmitterID.trim() : "",
                }
            })
        }
        success(list)
    }, fail)
}

export const getICDCodes = (
    type: ICDType,
    keyword: string,
    clinicID: number,
    success: (list: Array<CodeItem>) => void,
    fail?: FailCallback) => {
    const param = {
        "type": type,
        "keyWords": keyword,
        "count": 100,
        "clinicID": clinicID,
    }
    sendRequest(ApiCampaign.getIcdCodes, param, (response) => {
        let list: Array<CodeItem> = []
        if (response.data && response.data.length) {
            list = response.data.map((_item: any) => {
                return {
                    name: _item.name,
                    code: _item.code,
                }
            })
        }
        success(list)
    }, fail)
}

export const getCPTCodes = (
    keyword: string,
    clinicID: number,
    success: (list: Array<CodeItem>) => void,
    fail?: FailCallback) => {
    const param = {
        "keyWords": keyword,
        "count": 100,
        "clinicID": clinicID,
    }
    sendRequest(ApiCampaign.getCptCodes, param, (response) => {
        let list: Array<CodeItem> = []
        if (response.data && response.data.length) {
            list = response.data.map((_item: any) => {
                return {
                    name: _item.name,
                    code: _item.code,
                }
            })
        }
        success(list)
    }, fail)
}

export const getLastDOSIdByDateTime = (from: string, to: string) => {
    const disabledDateTime = "0001-01-01T00:00:00Z"
    if (!from || !to || from === disabledDateTime || to === disabledDateTime) {
        return undefined
    }
    const fromM = moment(new Date(from))
    if (moment(new Date(to)).subtract(7, "days")
        .isSame(fromM, "day")) {
        return LastDOS.lastWeek
    } else if (moment(new Date(to)).subtract(14, "days")
        .isSame(fromM, "day")) {
        return LastDOS.last2Week
    } else if (moment(new Date(to)).subtract(1, "month")
        .isSame(fromM, "day")) {
        return LastDOS.lastMonth
    } else if (moment(new Date(to)).subtract(2, "months")
        .isSame(fromM, "day")) {
        return LastDOS.last2Months
    } else if (moment(new Date(to)).subtract(6, "months")
        .isSame(fromM, "day")) {
        return LastDOS.last6Months
    } else if (moment(new Date(to)).subtract(12, "months")
        .isSame(fromM, "day")) {
        return LastDOS.last12Months
    }
    return undefined

}

// const getLastDOSDateByDOSId = (id: LastDOS | string): {from: string | undefined, to: string | undefined} => {
//     let item: {from: string | undefined, to: string | undefined} = {from: undefined, to: undefined}
//     if (id === LastDOS.lastWeek) {
//         const toM = moment(new Date()).subtract(7, "days")
//         const to = new Date(toM.year(), toM.month(), toM.date(), 0, 0, 0, 0)
//         item.to = to.toISOString()
//     } else if (id === LastDOS.last2Week) {
//         const toM = moment(new Date()).subtract(14, "days")
//         const to = new Date(toM.year(), toM.month(), toM.date(), 0, 0, 0, 0)
//         item.to = to.toISOString()
//     } else if (id === LastDOS.lastMonth) {
//         const toM = moment(new Date()).subtract(1, "month")
//         const to = new Date(toM.year(), toM.month(), toM.date(), 0, 0, 0, 0)
//         item.to = to.toISOString()
//     } else if (id === LastDOS.last2Months) {
//         const toM = moment(new Date()).subtract(2, "months")
//         const to = new Date(toM.year(), toM.month(), toM.date(), 0, 0, 0, 0)
//         item.to = to.toISOString()
//     } else if (id === LastDOS.last6Months) {
//         const toM = moment(new Date()).subtract(6, "months")
//         const to = new Date(toM.year(), toM.month(), toM.date(), 0, 0, 0, 0)
//         item.to = to.toISOString()
//     } else if (id === LastDOS.last12Months) {
//         const toM = moment(new Date()).subtract(12, "months")
//         const to = new Date(toM.year(), toM.month(), toM.date(), 0, 0, 0, 0)
//         item.to = to.toISOString()
//     }
//     if (item.to) {
//         const fromM = moment(new Date())
//         item.from = new Date(fromM.year(), fromM.month(), fromM.date(), 0, 0, 0, 0).toISOString()
//     }
//     return item
// }

const getPatientFilterByGroupSetting = (groupSetting: NewGroupSetting, pageId = 0, onePageCount = 0, onlyGetCount = 1, excludePatientIds?: Array<number>, sortBy?: PatientSortConfig): any => {
    const chronicConditions = groupSetting.chronicCondition
    const playTypes = groupSetting.planType !== DropdownListFormNotSelectedStringId ? [groupSetting.planType] : []
    const insurances = groupSetting.insurance !== DropdownListFormNotSelectedStringId ? [groupSetting.insurance] : []
    const fromAge = check3DigitalNumber(groupSetting.fromAge) ? parseInt(groupSetting.fromAge) : undefined
    const toAge = check3DigitalNumber(groupSetting.toAge) ? parseInt(groupSetting.toAge) : undefined
    const ageType = groupSetting.ageType
    const gender = groupSetting.gender !== DropdownListFormNotSelectedStringId ? groupSetting.gender : undefined
    const preferredContact = groupSetting.preferredContact !== DropdownListFormNotSelectedStringId ? groupSetting.preferredContact : undefined
    const preferredLanguage = groupSetting.preferredLanguage !== DropdownListFormNotSelectedStringId ? groupSetting.preferredLanguage : undefined
    const appointmentType = groupSetting.appointmentType !== DropdownListFormNotSelectedStringId ? parseInt(groupSetting.appointmentType) : undefined
    const patientPanel = groupSetting.patientPanel !== DropdownListFormNotSelectedStringId ? groupSetting.patientPanel : undefined
    const icdCodes = groupSetting.icd.map(({code}) => code)
    const excludeIcdCodes = groupSetting.excludeIcd.map(({code}) => code)
    const cptCodes = groupSetting.cpt.map(({code}) => code)
    const excludeCptCodes = groupSetting.excludeCpt.map(({code}) => code)

    // const lastDOS = getLastDOSDateByDOSId(groupSetting.lastDOS)

    let icdPeriodFrom, icdPeriodTo, icdPeriodExFrom, icdPeriodExTo, cptPeriodFrom, cptPeriodTo, cptPeriodExFrom, cptPeriodExTo

    if (excludeIcdCodes.length) {
        icdPeriodExFrom = groupSetting.icdFrom?.toISOString()
        icdPeriodExTo = groupSetting.icdTo?.toISOString()
    } else {
        icdPeriodFrom = groupSetting.icdFrom?.toISOString()
        icdPeriodTo = groupSetting.icdTo?.toISOString()
    }

    if (excludeCptCodes.length) {
        cptPeriodExFrom = groupSetting.cptFrom?.toISOString()
        cptPeriodExTo = groupSetting.cptTo?.toISOString()
    } else {
        cptPeriodFrom = groupSetting.cptFrom?.toISOString()
        cptPeriodTo = groupSetting.cptTo?.toISOString()
    }

    const lastDosFrom = groupSetting.dosFrom?.toISOString()
    const lastDosTo = groupSetting.dosTo?.toISOString()

    return {
        "pageId": pageId,
        "onePageCount": onePageCount,
        "onlyGetCount": onlyGetCount,
        "patientSortConfig": sortBy,
        "excludePatientIds": excludePatientIds || [],
        "patientFilter": {
            "patientName": groupSetting.patientName,
            "fromAge": ageType === AgeType.byYear ? fromAge : undefined,
            "toAge": ageType === AgeType.byYear ? toAge : undefined,
            "fromMonth": ageType === AgeType.byMonth ? fromAge : undefined,
            "toMonth": ageType === AgeType.byMonth ? toAge : undefined,
            "gender": gender,
            "preferredContact": preferredContact,
            "preferredLanguage": preferredLanguage,
            "lastDosFrom": lastDosFrom,
            "lastDosTo": lastDosTo,
            "appointmentType": appointmentType,
            "appointmentFrom": undefined,
            "appointmentTo": undefined,
            "chronicCondition": chronicConditions,
            "planType": playTypes,
            "insurance": insurances,
            "icdCodes": icdCodes,
            "icdExclusion": excludeIcdCodes,
            "icdPeriodFrom": icdPeriodFrom,
            "icdPeriodTo": icdPeriodTo,
            "icdPeriodExFrom": icdPeriodExFrom,
            "icdPeriodExTo": icdPeriodExTo,
            "cptCodes": cptCodes,
            "cptExclusion": excludeCptCodes,
            "cptPeriodFrom": cptPeriodFrom,
            "cptPeriodTo": cptPeriodTo,
            "cptPeriodExFrom": cptPeriodExFrom,
            "cptPeriodExTo": cptPeriodExTo,
            "patientPanel": patientPanel,
            "iClinicHealth": 0,
        },
    }
}

export const getPatientByFilter = (groupSetting: NewGroupSetting, pageId: number, onePageCount: number, onlyGetCount: number, excludePatientIds: Array<number>, success: (patientList: Array<PatientPreview>, totalCount: number) => void, fail: FailCallback) => {
    const param = getPatientFilterByGroupSetting(groupSetting, pageId, onePageCount, onlyGetCount, excludePatientIds)
    sendRequest(ApiCampaign.getPatientsByFilter, param, (response) => {
        success(processPreviewPatients(response.data), response.totalCount)
    }, fail)
}

export const getPatientByFilterWithSort = (groupSetting: NewGroupSetting, pageId: number, onePageCount: number, onlyGetCount: number, excludePatientIds: Array<number>, sortBy: PatientSortConfig, success: (patientList: Array<PatientPreview>, totalCount: number) => void, fail: FailCallback) => {
    const param = getPatientFilterByGroupSetting(groupSetting, pageId, onePageCount, onlyGetCount, excludePatientIds, sortBy)
    sendRequest(ApiCampaign.getPatientsByFilter, param, (response) => {
        success(processPreviewPatients(response.data), response.totalCount)
    }, fail)
}

export const getPatientsByName = (name: string, success: (patient: any) => void, fail: FailCallback) => {
    const param = {
        "pageId": 1,
        "onePageCount": 20,
        "onlyGetCount": 0,
        "patientFilter": {
            "patientName": name,
        },
    }
    sendRequest(ApiCampaign.getPatientsByFilter, param, (response) => {
        if (response && response.data) {
            success && success(response.data)
        } else {
            success && success([])
        }
    }, fail)
}

export const savePatientGroup = (
    groupSetting: NewGroupSetting,
    groupEmployee: GroupEmployee,
    excludePatients: Array<SelectPatient>,
    success: () => void,
    fail: FailCallback
) => {
    const param = {
        patientGroup: {
            groupId: groupSetting.id,
            groupName: groupSetting.groupName,
            employee: groupEmployee,
            excludePatientIds: excludePatients.map((pt) => ({patientID: pt.patientId, clinicID: pt.clinicId})),
            patientFilter: getPatientFilterByGroupSetting(groupSetting).patientFilter,
        },
    }
    sendRequest(ApiCampaign.savePatientGroup, param, (response) => {
        success()
        response?.data?.groupId && sessionStorage.setItem("selected_group_id", response.data.groupId)
    }, fail)
}

const convertUTCToDate = (dateUTC: string): string => {
    const date = new Date(dateUTC)
    return moment(date).format(TimeFormat.YYYYMMDD)
}

const processPreviewPatients = (responseData: Array<any>): Array<PatientPreview> => {
    let list: Array<PatientPreview> = []
    if (responseData && responseData.length) {
        list = responseData.map((_item: any) => {
            const patientFullName = `${_item.firstName} ${_item.lastName}`
            const dob = convertUTCToDate(_item.dob)
            const {chronicDisease, manageStatus, lastEncounter} = _item
            const lastAttempt = manageStatus && manageStatus.lastAttempt ? convertUTCToDate(manageStatus.lastAttempt) : ""
            const lastVisit = lastEncounter && lastEncounter.dos ? convertUTCToDate(lastEncounter.dos) : ""

            let chronicDiseaseList: Array<ChronicDisease> = []
            if (chronicDisease) {
                if (chronicDisease.asthma) {
                    chronicDiseaseList.push(ChronicDisease.asthma)
                }
                if (chronicDisease.hypertension) {
                    chronicDiseaseList.push(ChronicDisease.hypertension)
                }
                if (chronicDisease.diabetes) {
                    chronicDiseaseList.push(ChronicDisease.diabetes)
                }
                if (chronicDisease.copd) {
                    chronicDiseaseList.push(ChronicDisease.copd)
                }
                if (chronicDisease.chronicDisease) {
                    chronicDiseaseList.push(ChronicDisease.chronicDisease)
                }
            }
            const qualityMeasures = _item.measures ? _item.measures.map((_measure: any) => {
                return _measure.measure
            }) : []
            return {
                clinicId: _item.clinicID,
                accountId: _item.accountID,
                mpid: _item.mpid,
                patientId: _item.patientID,
                name: patientFullName,
                dob: dob,
                gender: _item.gender,
                mobilePhone: _item.mobilePhone,
                homePhone: _item.homePhone,
                email: _item.email,
                lastVisit: lastVisit,
                chronicDisease: chronicDiseaseList,
                qualityMeasures: qualityMeasures,
                lastAttempt: lastAttempt,
                source: _item,
            }
        })
    }
    return list
}

export const getPatientsByGroup = (
    groupId: string,
    page: number,
    pageSize: number,
    sortBy: PatientSortConfig,
    success: (patientList: Array<PatientPreview>, total: number) => void,
    fail: FailCallback
) => {
    const param = {
        "pageId": page,
        "onePageCount": pageSize,
        "groupId": groupId,
        "patientSortConfig": sortBy,
    }
    sendRequest(ApiCampaign.getPatientsByGroup, param, (response) => {
        let list: Array<PatientPreview> = processPreviewPatients(response.data)
        let total = response.totalCount || 0
        success(list, total)
    }, fail)
}

export const deletePatientGroup = (groupId: string, success: () => void, fail: FailCallback) => {
    const param = {
        groupId: groupId,
    }
    sendRequest(ApiCampaign.deletePatientGroup, param, () => {
        success && success()
    }, fail)
}

export const excludePatientsInGroup = (groupId: string, patients: Array<SelectPatient>, success: () => void, fail: FailCallback) => {
    const param = {
        groupId: groupId,
        excludePatientIds: patients.map((pt) => {
            return {
                clinicID: pt.clinicId,
                patientID: pt.patientId,
            }
        }),
    }
    sendRequest(ApiCampaign.excludeGroupPatients, param, () => {
        success && success()
    }, fail)
}

export const getCodeTemplate = (clinicId: number, codeType: CodeSelectorType, success: (list: Array<CodeTemplateItem>) => void, fail: FailCallback) => {
    const param = {
        "clinicID": clinicId,
        "templateType": codeType === CodeSelectorType.icd ? "ICD" : "CPT",
    }
    sendRequest(ApiCampaign.getIcdCptTemplates, param, (response) => {
        let list: Array<CodeTemplateItem> = []
        if (response && response.data) {
            list = response.data.map(({templateId, templateName}: any) => {
                return {
                    name: templateName,
                    id: templateId,
                }
            })
        }
        success && success(list)
    }, fail)
}

export const getTemplateCodes = (
    clinicId: number,
    codeType: CodeSelectorType,
    templateId: string | number,
    success: (list: Array<CodeItem>) => void,
    fail: FailCallback) => {
    const param = {
        "clinicID": clinicId,
        "templateType": codeType === CodeSelectorType.icd ? "ICD" : "CPT",
        "templateId": templateId,
    }
    sendRequest(ApiCampaign.getTemplateCodes, param, (response) => {
        let list: Array<CodeItem> = []
        if (response && response.data) {
            list = response.data.map(({code, name}: any) => {
                return {
                    name: name,
                    code: code,
                }
            })
        }
        success && success(list)
    }, fail)
}

const preparePatientFilter = (filterConfig: PatientFilterConfig) => {
    const {keyword, statuses, openRate, sortField, isAscending} = filterConfig
    const param: any = {
        keyWord: keyword,
        selStatus: statuses,
        sortField: sortField,
        descSort: !isAscending,
    }
    if (openRate === OpenRate.lessThan30) {
        param.beginOpenRate = 0
        param.endOpenRate = 0.3
    } else if (openRate === OpenRate.between30and50) {
        param.beginOpenRate = 0.3
        param.endOpenRate = 0.5
    } else if (openRate === OpenRate.moreThan50) {
        param.beginOpenRate = 0.5
        param.endOpenRate = 1
    }
    return param
}

export interface PatientFilterConfig {
    keyword: string,
    statuses: Array<SubscribeStatus>,
    openRate: OpenRate | undefined,
    sortField: string,
    isAscending: boolean,
}

const processPatients = (responseData: Array<any>): Array<Patient> => {
    let list: Array<Patient> = []
    if (responseData && responseData.length) {
        list = responseData.map((_item: any) => {
            return {
                clinicId: _item.clinicID,
                patientId: _item.patientID,
                patientName: _item.patientName,
                dob: convertUTCToDate(_item.dob),
                gender: _item.gender,
                mobilePhone: _item.mobilePhone,
                homePhone: _item.homePhone,
                email: _item.email,
                openRate: _item.openRate,
                status: _item.status,
                lastAttempt: _item.lastAttempt === "0001-01-01T00:00:00" ? "" : convertUTCToDate(_item.lastAttempt),
            }
        })
    }
    return list
}

export const getAllPatients = (
    filterConfig: PatientFilterConfig,
    page: number,
    pageSize: number,
    success: (patientList: Array<Patient>, totalCount: number) => void,
    fail?: FailCallback) => {
    const param: any = {
        ...preparePatientFilter(filterConfig),
        pageIndex: page,
        pageSize: pageSize,
    }
    sendRequest(ApiCampaign.getAllPatients, param, (response) => {
        success && success(processPatients(response.data), response.totalCount)
    }, fail)
}

export const exportPatients = (
    filterConfig: PatientFilterConfig) => {
    const param = {
        // 0: excel; 1: csv
        fileType: 1,
        filter: preparePatientFilter(filterConfig),
    }
    const fileName = `patients-${moment().format(TimeFormat.YYYYMMDD)}.csv`
    fetchFile(ApiCampaign.exportPatients, fileName, param)
}
